import Api from "../config/api";

export const findAllRegistroHoraProfissional = async ({ dataInicio, dataFim, pageableDTO }) => {
  const response = await Api.post("", {
    query: `
      query ($dataInicio: LocalDate, $dataFim: LocalDate, $pageableDTO: PageableDTOInput) {
        findAllRegistroHoraProfissional(dataInicio: $dataInicio, dataFim: $dataFim, pageableDTO: $pageableDTO) {
          content {
            id
            data
            horaInicio
            horaFim
            profissionalSaude {
              id
              nome
            }
          }
          last
          totalElements
        }
      }
    `,
    variables: { dataInicio, dataFim, pageableDTO },
  });

  if (response.data.errors) {
    throw Error("Falha ao carregar registros de hora.");
  }

  return response.data.data.findAllRegistroHoraProfissional;
};

export const findAllRegistroHoraProfissionalByProfissional = async ({ profissionalSaudeId, dataInicio, dataFim, pageableDTO }) => {
  const response = await Api.post("", {
    query: `
      query ($profissionalSaudeId: Long, $dataInicio: LocalDate, $dataFim: LocalDate, $pageableDTO: PageableDTOInput) {
        findAllRegistroHoraProfissionalByProfissional(profissionalSaudeId: $profissionalSaudeId, dataInicio: $dataInicio, dataFim: $dataFim, pageableDTO: $pageableDTO) {
          content {
            id
            data
            horaInicio
            horaFim
            profissionalSaude {
              id
              nome
            }
          }
          last
          totalElements
        }
      }
    `,
    variables: { profissionalSaudeId, dataInicio, dataFim, pageableDTO },
  });

  if (response.data.errors) {
    throw Error("Falha ao carregar registros de hora do profissional.");
  }

  return response.data.data.findAllRegistroHoraProfissionalByProfissional;
};


export const criarRegistroHoraProfissional = async ({ profissionalSaudeId, unidadeId, data, horaInicio, horaFim }) => {
  const response = await Api.post("", {
    query: `
      mutation ($registroHoraProfissional: RegistroHoraProfissionalInput) {
        criarRegistroHoraProfissional(registroHoraProfissional: $registroHoraProfissional) {
          id
          data
          horaInicio
          horaFim
        }
      }
    `,
    variables: {
      registroHoraProfissional: {
        profissionalSaude: { id: profissionalSaudeId },
        unidade: { id: unidadeId },
        ...(data && { data }),
        horaInicio,
        ...(horaFim && { horaFim }),
      },
    },
  });

  if (response.data.errors) {
    throw Error("Falha ao criar registro de hora.");
  }

  return response.data.data.criarRegistroHoraProfissional;
};

export const atualizarRegistroHoraProfissional = async ({ id, horaInicio, horaFim }) => {
  const response = await Api.post("", {
    query: `
      mutation ($id: UUID, $horaInicio: LocalTime, $horaFim: LocalTime) {
        atualizarRegistroHoraProfissional(id: $id, horaInicio: $horaInicio, horaFim: $horaFim) {
          id
          data
          horaInicio
          horaFim
        }
      }
    `,
    variables: { id, horaInicio, horaFim },
  });

  if (response.data.errors) {
    throw Error("Falha ao atualizar registro de hora.");
  }

  return response.data.data.atualizarRegistroHoraProfissional;
};

export const definirDataCorteRegistroHora = async ({ profissionalSaudeId, dataCorte }) => {
  const response = await Api.post("", {
    query: `
      mutation ($profissionalSaudeId: Long, $dataCorte: Int) {
        definirDataCorteRegistroHora(profissionalSaudeId: $profissionalSaudeId, dataCorte: $dataCorte) {
          id
          nome
          dataCorte
        }
      }
    `,
    variables: { profissionalSaudeId, dataCorte },
  });

  if (response.data.errors) {
    throw Error("Falha ao definir data de corte.");
  }

  return response.data.data.definirDataCorteRegistroHora;
};

export const inativarRegistroHoraProfissional = async ({ id }) => {
  const response = await Api.post("", {
    query: `
      mutation ($id: UUID) {
        inativarRegistroHoraProfissional(id: $id) {
          id
        }
      }
    `,
    variables: { id },
  });

  if (response.data.errors) {
    throw Error("Falha ao inativar registro de hora.");
  }

  return response.data.data.inativarRegistroHoraProfissional;
};
